import { siteReviewAreaLabel, type SiteReviewDto, type SiteReviewStatus } from '@daevio/shared';
import { pathOf } from '../lib/format.ts';

const SCORE_WORD = ['', 'Poor', 'Weak', 'Fair', 'Good', 'Strong'];

function Score({ score }: { score: number }) {
  return (
    <span className={`review-score score-${score}`} aria-label={`${score} out of 5, ${SCORE_WORD[score]?.toLowerCase()}`}>
      <span className="review-pips" aria-hidden="true">
        {[1, 2, 3, 4, 5].map((n) => (
          <span key={n} className={n <= score ? 'pip on' : 'pip'} />
        ))}
      </span>
      <span className="review-score-word">{SCORE_WORD[score]}</span>
    </span>
  );
}

/** Instant review of the site (F3): ready in seconds, while the visits run. */
export function SiteReview({ status, review }: { status: SiteReviewStatus; review: SiteReviewDto | null }) {
  return (
    <section className="site-review" aria-label="Site review" aria-busy={status === 'pending'}>
      <h2>First impression</h2>
      {status === 'pending' && (
        <p className="muted review-pending">
          <span className="pulse" aria-hidden="true" />
          Reading your home page and key pages…
        </p>
      )}
      {status === 'failed' && !review && (
        <p className="muted">We could not read the site's pages for the quick review. The visitors' findings below are not affected.</p>
      )}
      {review && (
        <>
          <p className="review-summary">{review.summary}</p>
          <ul className="review-areas">
            {review.areas.map((a) => (
              <li key={a.area} className="review-area">
                <div className="review-area-head">
                  <h3>{siteReviewAreaLabel[a.area]}</h3>
                  <Score score={a.score} />
                </div>
                <p>{a.verdict}</p>
                {a.findings.length > 0 && (
                  <ul className="review-findings">
                    {a.findings.map((f) => (
                      <li key={f}>{f}</li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
          <p className="muted small">
            Read from {review.pages.map((p) => pathOf(p.url)).join(', ')}.
          </p>
        </>
      )}
    </section>
  );
}
